export default {
    "fr": {
        "Contact us": "Nous contacter",
        "We will answer you as soon as possible": "Nous vous répondrons aussi vite que possible",
        "Your message is on our mailbox": "Nous avons bien reçu votre message",
        "Send": "Envoyer",
        "Optin message": "En soumettant ce formulaire, j'accepte que les informations saisies soient exploitées dans le cadre de ma demande d'information et de la relation commerciale qui peut en découler. (obligatoire)",
        "Thanks for your message": "Merci pour votre message. On reviens vers vous d'ici peu !"
    },
    "en": {
        "Contact us": "Contact us",
        "We will answer you as soon as possible": "We will answer you as soon as possible",
        "Your message is on our mailbox": "Your message is on our mailbox",
        "Send": "Send",
        "Optin message": "By submitting this form, I accept that the information entered will be used as part of my request for information and the commercial relationship that may result from it. (required)",
        "Thanks for your message": "Thanks for your message"
    }
}
